import Login from './Login';

export const LoginConfig = {
    settings: {
      layout          : {
        style : 'layout2',
        config: {
          scroll : 'content',
          navbar : {
            display : false,
            folded  : false,
            position: 'left'
          },
          toolbar: {
            display : false,
            style   : 'fixed',
            position: 'below'
          },
          footer : {
            display : false,
            style   : 'fixed',
            position: 'below'
          },
          mode   : 'fullwidth'
        }
      },
    },
    routes  : [
        {
            path     : '/login',
            component: Login
        }
    ]
};
